import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { OwnerAssetsSchema } from '../../owner/asset.js';
import { OwnerAuth0Schema } from '../../owner/auth0.js';
import { OwnerOptionsSchema } from '../../owner/options.js';
import { OwnerBrandSchema, OwnerCornSchema, OwnerSchema } from '../../owner/owner.js';
import { OwnerEmailEnvelopeSchema } from '../../owner/email.js';
export const PutOwnerApiSchema = {
    body: z.object({
        auth0: OwnerAuth0Schema,
        brand: OwnerBrandSchema.omit({ assets: true, emailEnvelope: true }).extend({
            assets: OwnerAssetsSchema.pick({
                assetBaseUrl: true,
                logoAlt: true,
                welcomeHeaderImageAlt: true,
                welcomeButtonLogoAlt: true,
            }),
            emailEnvelope: OwnerEmailEnvelopeSchema.omit({
                emailReceivingDomain: true,
                emailSenderSuffix: true,
            }),
        }),
        options: OwnerOptionsSchema.optional(),
        displayName: z.string().min(1),
    }),
    params: z.object({
        ownerId: OwnerCornSchema,
    }),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
    response: OwnerSchema,
};
export const PutOwnerRequestSchema = z.object({
    ...PutOwnerApiSchema.body.shape,
    ...PutOwnerApiSchema.headers.shape,
    ...PutOwnerApiSchema.params.shape,
});
export const PutOwnerResponseSchema = PutOwnerApiSchema.response;
